import { Navigate } from 'react-router-dom'
import { useSessionInfo } from '../../contexts/SessionContext'
import { isUserAdmin } from '../../utils/authUtils'

interface ProtectedAdminRouteProps {
  children: React.ReactNode
}

const ProtectedAdminRoute = ({ children }: ProtectedAdminRouteProps) => {
  const { session } = useSessionInfo()
  if (!session?.user?.id || !isUserAdmin(session.user.id)) {
    return <Navigate to='/' replace />
  }

  return <>{children}</>
}

export default ProtectedAdminRoute
